/**
 * Calculate stars for a completed puzzle.
 * - 3 stars: no undo AND steps ≤ optimal (any starting position)
 * - 2 stars: 1-2 undos, or steps above optimal
 * - 1 star: 3+ undos
 */
export function calculateStars(
  steps: number,
  optimalSteps: number,
  undoCount: number,
): number {
  if (undoCount >= 3) return 1;
  if (undoCount > 0 || steps > optimalSteps) return 2;
  return 3;
}
